import * as React from "react";

function SvgLeaf(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400.174 400.174"
      {...props}
    >
      <path
        d="M201.38 88.422c113.12-12.44 149.88-84 150-84a7.28 7.28 0 0113.48 1.44c37.6 127.52 17.08 215.44-26.08 267.6a162.364 162.364 0 01-62.36 46.52 155.36 155.36 0 01-70.8 12c-46.36-3.24-88.68-28-108.32-72.36a120.552 120.552 0 01-9.64-35.72 122.804 122.804 0 0113.84-71.6 118.8 118.8 0 0157.08-52.48 143.742 143.742 0 0142.8-11.4z"
        fill="#45b549"
      />
      <path
        d="M350.58 7.102a7.28 7.28 0 1114.479 1.24c0 .36-6.36 84-88 168.64l-.76.8a424.34 424.34 0 01-62.84 53.04l49.04 9.12a7.28 7.28 0 01-2.44 14.32l-64-12c-58.36 36.96-157.28 71.08-165.92 151.6a7.28 7.28 0 01-14.48-1.44c10.32-96.52 108.4-121.36 174.56-163.56l.92-.6a420.42 420.42 0 0072.92-58.44l-5.8-57.4a7.28 7.28 0 1114.48-1.44l4.4 44.56c68.041-76.4 73.401-148.12 73.441-148.44z"
        fill="#009549"
      />
    </svg>
  );
}

export default SvgLeaf;
